<div style="position: relative;" (appClickOutside)="isShowColorPicker = false" data-cy="color-picker-container">
  <mat-form-field *ngIf="showInputField == true" style="width:100%; margin-top: 3px;" data-cy="color-picker-form-field">
    <!--<mat-label>Color</mat-label>-->
    <input (click)="isShowColorPicker=true" (input)="color = $event.target.value" [placeholder]="placeholder"
           [value]="color" autoComplete="off"
           matInput data-cy="color-picker-input"/>
    <div (click)="isShowColorPicker=true" [style.backgroundColor]="color" class="color-picker-box" matPrefix
         style="width: 10px; height: 10px; margin-right: 6px" matTooltip="Select color" data-cy="color-picker-box-prefix"></div>
  </mat-form-field>
  <div *ngIf="showInputField == false" data-cy="color-picker-no-input-field-container">
    <div *ngIf="showLabel == true" style="font-size: 11px; opacity: 0.7; font-family: Roboto,serif; letter-spacing: 1px;" [style.color]="labelColor" data-cy="color-picker-label">{{label}}</div>
    <div (click)="isShowColorPicker=true" [style.backgroundColor]="color" [style.width.px]="width" [style.height.px]="height"
         class="color-picker-box" style="margin-left: 3px; margin-top: 3px;" matTooltip="Select color" data-cy="color-picker-box"></div>
  </div>
  <div style="position: absolute; z-index: 100; opacity: 0.9;" [style.top]="positionY + 'px'" data-cy="color-picker-chrome-container">
    <color-chrome (onChangeComplete)="onColorChange($event)" *ngIf="isShowColorPicker" [color]="color" disableAlpha="true"
                  style="left: 0; top: 0;" data-cy="color-picker-chrome"></color-chrome>
  </div>
</div>
